export default function(arr, key) {
  return arr.reduce((acc, el) => {
    if (!acc.some(arrEl => arrEl[key] === el[key])) {
      return [...acc, el];
    }
    return acc;
  }, []);
}